import React, { type ReactNode } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { cn } from "~/lib/utils";
import { hasMeaningfulChildren } from "~/lib/react-utils";

interface BuilderCardProps {
  title?: string;
  description?: string;
  fillHeight?: boolean;
  children?: ReactNode;
}

export const BuilderCard = ({
  title,
  description,
  fillHeight,
  children,
}: BuilderCardProps) => (
  <Card className={cn("flex flex-col", { "h-full": fillHeight })}>
    {(title || description) && (
      <CardHeader>
        {title && <CardTitle>{title}</CardTitle>}
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
    )}
    {hasMeaningfulChildren(children) && (
      <CardContent className="flex grow flex-col gap-2">{children}</CardContent>
    )}
  </Card>
);
